/**
 * Every icon's Softmax semantic name, without the glyphs (so views can name icons where React isn't loaded). The
 * table in `../icons.tsx` must cover exactly these; the compiler checks it.
 */
export const ICON_NAMES = [
  'sort',
  'sort-ascending',
  'sort-descending',
  'check',
  'panel-left',
  'menu',
  'expand',
  'collapse',
  'pause',
  'play',
  'microphone',
  'microphone-off',
  'pen',
  'bookmark',
  'note',
  'user',
  'help',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'close',
  'copy',
  'delete',
  'dashboard',
  'policy',
  'coworld',
  'leaderboard',
  'cogent',
  'opponent',
  'player',
  'back',
  'send',
  'add',
  'refresh',
  'external',
  'sign-in',
  'sign-out',
  'account',
  'nav-auto',
  'nav-labels',
  'nav-icons',
  'grip',
  'live',
  'time',
  'thread',
  'loading',
  'sound-on',
  'sound-off',
  'mind',
  'personality',
  'customize',
  'presets',
  'head',
  'body',
  'hands',
  'legs',
  'colors',
  'voice',
  'lock',
  'undo',
  'reset',
  'randomize',
  'none',
  'done',
  'docker',
  'file',
  'folder',
  'save',
  'terminal',
  'recommended',
  'warning',
  'upload',
  'search',
  'trend-up',
  'trend-down',
  'steady',
  'filter',
  'credits',
  'forward',
  'code',
  'loop',
  'folder-closed',
  'discovery',
  'neuron',
  'edge',
  'goal',
  'chart',
  'pin',
  'shapes',
  'page',
  'layout',
  'drag',
  'blueprint',
] as const

export type IconName = (typeof ICON_NAMES)[number]
